import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ContentSmallComponent } from './content-small.component'

@NgModule({
  declarations: [ContentSmallComponent],
  imports: [CommonModule],
  exports: [ContentSmallComponent]
})
export class ContentSmallModule {}
